'use es6';

import { formatCurrencyCode } from '../internal/utils/CurrencyLabelFormatters';
export default formatCurrencyCode;